"use client";

import * as RadixSwitch from "@radix-ui/react-switch";
import { useId } from "react";
import type { ReactNode } from "react";

export interface SwitchProps {
  label: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
}

/** Binary configuration state. Does not persist until the surrounding form saves. */
export function Switch({ label, checked, onCheckedChange, disabled, id }: SwitchProps) {
  const autoId = useId();
  const switchId = id ?? autoId;
  return (
    <div className="ui-option-row">
      <RadixSwitch.Root
        id={switchId}
        className="ui-switch-root"
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      >
        <RadixSwitch.Thumb className="ui-switch-thumb" />
      </RadixSwitch.Root>
      <label htmlFor={switchId}>{label}</label>
    </div>
  );
}
